
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "search",
  "title": "Search & Filters",
  "sidebar_label": "Search & Filters"
};
const slug = 'search';
const tableOfContents = [];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <p>{`User able to do advanced search of listings through search function to find the accurate things`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.tradly.app/#d929750b-182c-4afc-999d-116fb532a320"
        }}>{`API REFERENCE for searching listings`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.tradly.app/#dca7dd7e-a370-448c-9778-a46ef066977d"
        }}>{`API REFERENCE for searching accounts`}</a></li>
    </ul>
    <p>{`Search feature that allows users to easily find listings that meet their needs and preferences. The search feature includes a range of options, including:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Traditional search by listing name and description.`}</li>
      <li parentName="ul">{`Advanced filters using attributes to narrow down the search results.`}</li>
      <li parentName="ul">{`Sorting options, such as by price or by most recent.`}</li>
      <li parentName="ul">{`Map-based filters that allow users to search for listings within a certain distance (e.g. in miles or kilometers).`}</li>
    </ul>
    <p>{`The filter options are automatically updated whenever new custom fields are added, allowing users to search and filter by a wide range of criteria. The filter options can also be deactivated if needed.`}</p>
    <p>{`Example filter options include:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`The user can select multiple options from a dropdown menu using the `}<inlineCode parentName="p">{`Multi select`}</inlineCode>{` filter type. For example, if the user is searching for listings that are available in multiple sizes, they can select all the sizes they are interested in from the dropdown menu.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The user can select a single option from a dropdown menu using the `}<inlineCode parentName="p">{`Single select`}</inlineCode>{` filter type. For example, if the user is searching for listings that are available in a specific color, they can select the color they are interested in from the dropdown menu.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The user can filter listings based on a color code using the `}<inlineCode parentName="p">{`Color code`}</inlineCode>{` filter type. For example, if the user is searching for listings that are available in a specific color, they can select the color they are interested in from a color picker.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The user can filter listings based on a range of numbers using the `}<inlineCode parentName="p">{`Number range`}</inlineCode>{` filter type. For example, if the user is searching for listings that are available within a specific price range, they can select the minimum and maximum price they are interested in from a range slider.`}</p>
      </li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
